export function stripeCheckoutReturnState(searchParams) {
  const stripeResult = searchParams.get('stripe');
  const sessionId = searchParams.get('session_id');

  if (stripeResult === 'cancel') {
    return {
      messageKey: 'stripe:messages.checkoutCanceled',
      severity: 'info',
      marksPaid: false,
      activatesPaymentMethod: false,
      sessionId,
    };
  }

  if (stripeResult === 'setup_cancel') {
    return {
      messageKey: 'stripe:messages.savedCardSetupCanceled',
      severity: 'info',
      marksPaid: false,
      activatesPaymentMethod: false,
      sessionId,
    };
  }

  if (stripeResult === 'setup_return') {
    return {
      messageKey: 'stripe:messages.savedCardWaitingForConfirmation',
      severity: 'info',
      marksPaid: false,
      activatesPaymentMethod: false,
      sessionId,
    };
  }

  if (stripeResult === 'success') {
    return {
      messageKey: 'stripe:messages.paymentSentWaitingForWebhook',
      severity: 'success',
      marksPaid: false,
      activatesPaymentMethod: false,
      sessionId,
    };
  }

  return null;
}
